import useSWR from 'swr';
import { fetcherGet } from './httpClient';
import { useAuth } from '../../context/AuthProvider';
import type { JobsResponse } from '../contracts/JobsResponse';

export const useGetJobs = (
  limit?: number,
  jobType?: string,
  options?: { refreshInterval?: number }
) => {
  const { session } = useAuth();
  let path = `jobs?jobType=${jobType}`;
  if (limit) {
    path += `&limit=${limit}`;
  }

  return useSWR<JobsResponse, Error>(
    session?.access_token ? ['jobs', jobType, session.access_token] : null,
    () => fetcherGet(path, { arg: {}, token: session?.access_token ?? '' }),
    {
      refreshInterval: options?.refreshInterval,
    }
  );
};
